import Vue from "vue";

// 表单预览态 全局组件
Vue.component("VFPreview", () => import(/* webpackChunkName:'lowcode-form' */ "@/CommonDP/pages/mainMg/lowcode/component/vFormRender-preview.vue"));
// 表单运行态 全局组件
Vue.component("VFRuntime", () => import(/* webpackChunkName:'lowcode-form' */ '@/CommonDP/pages/mainMg/lowcode/component/vFormRender.vue'));

// 按需引入
import BaseRender from "@/CommonDP/lib/tableDesign/index.js";
Vue.use(BaseRender);

Vue.component("tableRender", () => import(/* webpackChunkName:'lowcode-table' */ "@/CommonDP/pages/commonRender/components/tableRender"));
Vue.component("dialogTable", () => import(/* webpackChunkName:'lowcode-table' */ "@/CommonDP/pages/commonRender/components/dialogTable"));

// 代码编辑器
Vue.component('JsCodeEditor', () => import(/* webpackChunkName:'lowcode-code' */ "@/CommonDP/components/jsCodeEditor"));
Vue.component('sqlCodeEditor', () => import(/* webpackChunkName:'lowcode-code' */ "@/CommonDP/components/sqlCodeEditor"));
